import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Col, Row } from "react-bootstrap";
//import EquityImg from "../../../Images/product-equity.png";
import ProductImg from "./../../../Images/home-products/equity.png";
import "./WelcomeEquity.css";
import { useEffect } from "react";
import TrackApi from "../../Activity_Track/TrackApi";
import { useCookies } from "react-cookie";
function WelcomeEquity() {
  let navigate = useNavigate();
  const routeChange = () => {
    let path = `/AllEquities`;
    navigate(path);
  };
  const [cookies, setCookie] = useCookies(['LeadId']);

  const trackData=(id)=>{
    const payloadData={
      "RelatedProspectId":id,
      "ActivityNote": "Your Equity Note",
      "mx_Custom_1": "Equity",
      "mx_Custom_2": "Your Equity page Note",
      "mx_CustomObject_81":window.location.href
     }
     TrackApi(payloadData);
  }
  useEffect(()=>{
  
if(cookies && cookies.RelatedProspectId){
  trackData(cookies.RelatedProspectId);
}
    
  },[])
  return (
    <>
      <section className="welcome-equity">
        <Container>
          <Row>
            <Col lg={4} md={6} sm={12}>
              <div className="welcome-img-block">
                <img className="img-fluid" src={ProductImg} alt="EquityImg" />
              </div>
            </Col>
            <Col lg={8} md={6} sm={12}>
              <div className="welcome-equity-beta">
                <h3>
                  <span>Equity</span>
                </h3>
                <p>
                  Equity is also known as shareholders' equity. Equity consists of money that would remain if company assets were sold and all of its debt was paid off. In a nutshell, equity is a company's net assets less liabilities. Equity is the company capital raised, which is then used to purchase assets, invests in projects, and acquisitions. Shareholders who own equity will also be able to vote on corporate actions and board of director elections. Shareholder equity can be positive or negative. If the equity position is positive, the company assets exceed its liabilities. If the balance is negative, the company liabilities exceed its assets. Equity can occasionally be offered as payment-in-kind.
                </p>
          
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default WelcomeEquity;
